import {
  RHFormConsumerTextField,
  RHFormConsumerTextFieldProps
} from "@RHCommerceDev/component-rh-text-field/RHFormConsumerTextField";
import React, { FC } from "react";
import memoize from "utils/memoize";

export const SmsCodeVerify: FC<RHFormConsumerTextFieldProps> = ({
  ...props
}) => {
  const rules = props.rules ? props.rules : {};
  const rulesProp = {
    required: props.required ? "Code required." : "",
    ...rules
  };

  return (
    <RHFormConsumerTextField
      defaultValue=""
      autoComplete="code"
      name={"code"}
      fullWidth
      label="Code"
      {...props}
      rules={rulesProp}
    />
  );
};

export default memoize(SmsCodeVerify);
